// @flow

import * as React from 'react';

type Props = {
  on?: boolean,
  toggle?: boolean => void,
  children: ({ on: boolean, toggle: () => void }) => React.Node,
};

type State = {
  on: boolean,
};

class Toggle extends React.Component<Props, State> {
  static defaultProps = {
    on: false,
    toggle: undefined,
  };

  state = {
    on: this.props.on || false,
  };

  toggle = (): void =>
    this.setState(
      (currentState: State): State => ({
        on: !currentState.on,
      }),
      (): boolean | void => this.props.toggle && this.props.toggle(this.state.on),
    );

  render(): React.Node {
    const {
      state: { on },
      toggle,
    } = this;

    return this.props.children({ on, toggle });
  }
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/Toggle/index.js